/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const createOptionValue = createAsyncThunk(
  'products/createOptionValue',
  async ({ productId, optionId, name }, {
    extra: { Logger, Toast, sdk },
  }) => {
    try {
      const { data } = await sdk.products.createOptionValues(productId, optionId, [name]);
      return data;
    } catch (error) {
      Toast(
        'Option value is not created. Refresh and try again',
        { autoClose: false, type: 'error' },
      );
      Logger.error(new Error('Error option value creating'), { error }, [
        'CreateOptionValueFailed',
        'Option value is not created on the backend.',
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    createOptionValue.pending,
    (state, { meta }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = true;
        }
      });
    },
  ).addCase(
    createOptionValue.fulfilled,
    (state, { payload }) => {
      state.items = state.items.map((product) => {
        if (product._id === payload._id) return { ...product, isBusy: false, ...payload };
        return product;
      });
    },
  ).addCase(
    createOptionValue.rejected,
    (state, { meta, error }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = false;
        }
      });
      state.error = error;
    },
  );
};
